import {Injector, NgModule} from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SpinElDirectiveModule } from '@signature-it/ngx-generic/directives';
import { AddToCartBtnModule } from './button/add-to-cart-btn.module';
import { quantitySelectorModule } from './quantity-selector/quantity-selector.module';
import { AddToCartComponent } from './add-to-cart.component';
import { SuccessModalModuleGeneric } from '@signature-it/ngx-catalogue/components/success-modal';
import {createCustomElement} from "@angular/elements";


@NgModule({
  declarations: [
      AddToCartComponent
  ],
  imports: [
      CommonModule,
      TranslateModule,
      SuccessModalModuleGeneric,
      FormsModule,
      RouterModule,
      SpinElDirectiveModule,
      AddToCartBtnModule,
      quantitySelectorModule
  ],
  exports: [
      AddToCartComponent
  ]
})
export class AddToCartModule {
    constructor(private injector: Injector) {
        const AddToCartComp = createCustomElement(AddToCartComponent, {injector});
        !customElements.get('ngx-add-to-cart') && customElements.define('ngx-add-to-cart', AddToCartComp);
    }
}
